module.exports = __webpack_public_path__ + "img/xiaoqu.9f3e9a81.png";